import React from 'react';
import { Icon } from './Icon.js';
export const IconGridLayout4Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("rect", { x: "2", y: "2", width: "6", height: "6", rx: "1.75", ry: "1.75", fill: "currentColor" }),
        React.createElement("rect", { x: "2", y: "10", width: "6", height: "6", rx: "1.75", ry: "1.75", fill: "currentColor" }),
        React.createElement("rect", { x: "10", y: "2", width: "6", height: "14", rx: "1.75", ry: "1.75", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconGridLayout4Fill18.js.map